



import React, { useState, useEffect } from 'react'; 
import axios from 'axios';
// import './KpiFormModal.css';

const KpiFormModal = ({ closeModal, fetchKpis, kpi }) => {
    const [metrics, setMetrics] = useState([]);
    const [selectedMetric, setSelectedMetric] = useState('');
    const [kpiName, setKpiName] = useState('');
    const [operationType, setOperationType] = useState('Aritmetica');
    const [arithmeticValue, setArithmeticValue] = useState('');
    const [comparisonOperator, setComparisonOperator] = useState('>');
    const [comparisonValue, setComparisonValue] = useState('');
    const [thenValue, setThenValue] = useState('');
    const [elseValue, setElseValue] = useState('');
    const [windowMinValue, setWindowMinValue] = useState('');
    const [windowMaxValue, setWindowMaxValue] = useState('');
    const [windowThenValue, setWindowThenValue] = useState('');
    const [windowElseValue, setWindowElseValue] = useState('');
    const [arithmeticOperator, setArithmeticOperator] = useState('+');

    useEffect(() => {
        if (kpi) {
            setSelectedMetric(kpi.metric_id || '');
            setKpiName(kpi.kpi_name || '');
            setOperationType(kpi.operation_type || 'Aritmetica');
            setArithmeticValue(kpi.arithmetic_value || '');
            setComparisonOperator(kpi.comparison_operator || '>');
            setComparisonValue(kpi.comparison_value || '');
            setThenValue(kpi.then_value || '');
            setElseValue(kpi.else_value || '');
            setWindowMinValue(kpi.window_min_value || '');
            setWindowMaxValue(kpi.window_max_value || '');
            setWindowThenValue(kpi.window_then_value || '');
            setWindowElseValue(kpi.window_else_value || '');
            setArithmeticOperator(kpi.arithmetic_operator || '+');
        }
    }, [kpi]);

    useEffect(() => {
        const fetchMetrics = async () => {
            try {
                const response = await axios.get('http://localhost:8000/device_metrics');
                setMetrics(response.data);
            } catch (error) {
                console.error('Error fetching metrics:', error);
            }
        };
        fetchMetrics();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const payload = {
            kpi_name: kpiName,
            metric_id: selectedMetric,
            operation_type: operationType,
            arithmetic_value: operationType === 'Aritmetica' ? Number(arithmeticValue) : null,
            arithmetic_operator: operationType === 'Aritmetica' ? arithmeticOperator : null,
            comparison_operator: operationType === 'ComparacionSencilla' ? comparisonOperator : null,
            comparison_value: operationType === 'ComparacionSencilla' ? Number(comparisonValue) : null,
            then_value: operationType === 'ComparacionSencilla' ? Number(thenValue) : null,
            else_value: operationType === 'ComparacionSencilla' ? Number(elseValue) : null,
            window_min_value: operationType === 'Ventana' ? Number(windowMinValue) : null,
            window_max_value: operationType === 'Ventana' ? Number(windowMaxValue) : null,
            window_then_value: operationType === 'Ventana' ? Number(windowThenValue) : null,
            window_else_value: operationType === 'Ventana' ? Number(windowElseValue) : null,
        };

        try {
            if (kpi?.id) {
                await axios.put(`http://localhost:8000/kpis/${kpi.id}`, payload);
                alert('KPI actualizado exitosamente');
            } else {
                await axios.post('http://localhost:8000/kpis', payload);
                alert('KPI creado exitosamente');
            }
            fetchKpis();
            closeModal();
        } catch (error) {
            console.error('Error al guardar el KPI:', error);
        }
    };

    return (
        <div className="modal-overlay-kpi">
            <div className="modal-content">
                <h2>{kpi?.id ? 'Editar KPI' : 'Crear KPI'}</h2>
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label>Nombre del KPI</label>
                        <input
                            type="text"
                            value={kpiName}
                            onChange={(e) => setKpiName(e.target.value)}
                            required
                        />
                    </div>

                    <div className="form-group">
                         <label>Métrica Base</label>
                         <select
                            value={selectedMetric}
                            onChange={(e) => setSelectedMetric(e.target.value)}
                            required
                        >
                            <option value="">Seleccione una Métrica</option>
                            {metrics.map((metric) => (
                                <option key={metric.id} value={metric.id}>
                                    {metric.visible_name}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="form-group">
                        <label>Tipo de Operación</label>
                        <select
                            value={operationType}
                            onChange={(e) => setOperationType(e.target.value)}
                        >
                            <option value="Aritmetica">Aritmética</option>
                            <option value="ComparacionSencilla">Comparación Sencilla</option>
                            <option value="Ventana">Ventana de Comparación</option>
                        </select>
                    </div>

                    {operationType === 'Aritmetica' && (
                        <div className="formula">
                            <span>KPI = </span>
                            <span className="metric-name">{selectedMetric || 'Métrica'}</span>
                            <select
                                className="operator"
                                value={arithmeticOperator}
                                onChange={(e) => setArithmeticOperator(e.target.value)}
                            >
                                <option value="+">+</option>
                                <option value="-">-</option>
                                <option value="*">×</option>
                                <option value="/">÷</option>
                            </select>
                            <input
                                type="number"
                                className="value-input"
                                value={arithmeticValue}
                                onChange={(e) => setArithmeticValue(e.target.value)}
                                placeholder="Valor"
                            />
                        </div>
                    )}

                    {operationType === 'ComparacionSencilla' && (
                        <div className="formula">
                            <span>Si </span>
                            <span className="metric-name">{selectedMetric || 'Métrica'}</span>
                            <select
                                className="operator"
                                value={comparisonOperator}
                                onChange={(e) => setComparisonOperator(e.target.value)}
                            >
                                <option value=">">mayor a</option>
                                <option value="<">menor a</option>
                                <option value="=">igual a</option>
                            </select>
                            <input
                                type="number"
                                className="value-input"
                                value={comparisonValue}
                                onChange={(e) => setComparisonValue(e.target.value)}
                                placeholder="Valor"
                            />
                            <span> entonces KPI = </span>
                            <input
                                type="number"
                                className="value-input"
                                value={thenValue}
                                onChange={(e) => setThenValue(e.target.value)}
                                placeholder="Valor KPI (si es verdadero)"
                            />
                            <span> de lo contrario KPI = </span>
                            <input
                                type="number"
                                className="value-input"
                                value={elseValue}
                                onChange={(e) => setElseValue(e.target.value)}
                                placeholder="Valor KPI (si es falso)"
                            />
                        </div>
                    )}

                    {operationType === 'Ventana' && (
                        <div className="formula">
                            <span>Si </span>
                            <span className="metric-name">{selectedMetric || 'Métrica'}</span>
                            <span> está entre </span>
                            <input
                                type="number"
                                className="value-input"
                                value={windowMinValue}
                                onChange={(e) => setWindowMinValue(e.target.value)}
                                placeholder="Mínimo"
                            />
                            <span> y </span>
                            <input
                                type="number"
                                className="value-input"
                                value={windowMaxValue}
                                onChange={(e) => setWindowMaxValue(e.target.value)}
                                placeholder="Máximo"
                            />
                            <span> entonces KPI = </span>
                            <input
                                type="number"
                                className="value-input"
                                value={windowThenValue}
                                onChange={(e) => setWindowThenValue(e.target.value)}
                                placeholder="Valor KPI (si es verdadero)"
                            />
                            <span> de lo contrario KPI = </span>
                            <input
                                type="number"
                                className="value-input"
                                value={windowElseValue}
                                onChange={(e) => setWindowElseValue(e.target.value)}
                                placeholder="Valor KPI (si es falso)"
                            />
                        </div>
                    )}

                    <div className="modal-buttons">
                        <button type="submit" className="create-button">{kpi?.id ? 'Actualizar KPI' : 'Crear KPI'}</button>
                        <button type="button" className="cancel-button" onClick={closeModal}>Cancelar</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default KpiFormModal;
